const AppConfig = {
  messageThreadRefreshTimeout: 10000,
  appAlertAutoHideDuration: 5000,
};

export default AppConfig;
